// @flow
import React from "react";
import FormsyEditorBase from "components/ExtraAttributes/EditorControl/FormsyEditorBase";
import GeoRadiusInput from "components/GeoRadiusInput";

type Props = {
    /** current value */
    value?: string,
    /** CSS classname to apply */
    className?: string,
    /** placeholder text to display when @see {value} is empty */
    placeholder?: string,
};

const GeoRadiusEditorControl = (props: Props) => (
    <FormsyEditorBase
        required={props.isRequired ? "isDefaultRequiredValue" : undefined}
        render={(value, changeValue) => (
            <GeoRadiusInput
                // label=""
                value={value || ""}
                onChange={
                    /* istanbul ignore next */ (value) =>
                        changeValue({ currentTarget: { value } })
                }
                onManualLocation={
                    /* istanbul ignore next */ (value) =>
                        changeValue({ currentTarget: { value } })
                }
                // style={props.style}
                className={props.className}
                placeholder={props.placeholder}
                id={props.name}
            />
        )}
        {...props}
    />
);
GeoRadiusEditorControl.displayName = "GeoRadiusEditorControl";
export default GeoRadiusEditorControl;
